module.exports = __webpack_public_path__ + "static/media/chevron-square-down.1d714ff8.svg";